import { render } from "./OrderWidget.vue?vue&type=template&id=18e3f7a8&scoped=true"
import script from "./OrderWidget.vue?vue&type=script&lang=js"
export * from "./OrderWidget.vue?vue&type=script&lang=js"

import "./OrderWidget.vue?vue&type=style&index=0&id=18e3f7a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e3f7a8"]])

export default __exports__